/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./route-title.component";
import * as i2 from "../../services/routing.service";
import * as i3 from "@angular/platform-browser";
var styles_UIRouteTitleComponent = [];
var RenderType_UIRouteTitleComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_UIRouteTitleComponent, data: {} });
export { RenderType_UIRouteTitleComponent as RenderType_UIRouteTitleComponent };
export function View_UIRouteTitleComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_UIRouteTitleComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ui-route-title", [], null, null, null, View_UIRouteTitleComponent_0, RenderType_UIRouteTitleComponent)), i0.ɵdid(1, 114688, null, 0, i1.UIRouteTitleComponent, [i2.RoutingService, i3.Title], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UIRouteTitleComponentNgFactory = i0.ɵccf("ui-route-title", i1.UIRouteTitleComponent, View_UIRouteTitleComponent_Host_0, {}, {}, []);
export { UIRouteTitleComponentNgFactory as UIRouteTitleComponentNgFactory };
